import { Component,ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal'

@Component({
  templateUrl: 'modals.component.html'
})
export class ModalsComponent {
  @ViewChild('staticModal') public staticModal:ModalDirective;
    public myModal;
    public largeModal;
    public smallModal;
    public primaryModal;
    public successModal;
    public warningModal;
    public dangerModal;
    public infoModal;
}
